'use client'

import styles from './product-styles.module.css'

import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'

import { Badge } from '@wartek-id/badge'
import { Icon } from '@wartek-id/icon'
import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text'

import { FLAG_KEY_RAPOR_PUBLIK } from '@/utils/toggle'
import { trackClickDashboardItem } from '@/utils/tracker/modules/prioritas'

import { ContainerNoPadding } from '@/components/Container'
import {
  DownloadSurveyProvider,
  useDownloadSurvey,
} from '@/components/DownloadSurvey/DownloadSurveyProvider'
import { LazyImg } from '@/components/LazyImg'
import { useIsActiveFF } from '@/components/WhitelistFfContext'

import { getProductDataSets, ProductDataSets } from './data'
import { ProductDataSet } from './data'

const ProductItem = ({ product }: { product: ProductDataSets }) => {
  const { showSurvey } = useDownloadSurvey()

  return (
    <section key={product.text} id={`row-${product.id}`}>
      <div>
        <div className="flex items-center gap-2">
          {product.logoExtraUrl ? (
            <>
              <LazyImg
                src={product.logoUrl}
                alt={product.text}
                height={40}
                width={40}
                useCdn={true}
                withWebp={true}
                className="h-auto max-h-[40px] w-auto"
              />
              {product.withText && (
                <Text variant="body-bold">{product.text}</Text>
              )}
              <Separator
                orientation="vertical"
                style={{
                  width: 2,
                  height: 40,
                }}
              />
              <LazyImg
                src={product.logoExtraUrl}
                alt={product?.extraText || ''}
                height={40}
                width={40}
                useCdn={true}
                withWebp={true}
                className="h-auto max-h-[40px] w-auto"
              />
              {product.withText && product.extraText && (
                <Text variant="body-bold">{product.extraText}</Text>
              )}
            </>
          ) : (
            <>
              <LazyImg
                src={product.logoUrl}
                alt={product.text}
                height={40}
                width={40}
                useCdn={true}
                withWebp={true}
                className="h-auto max-h-[40px] w-auto"
              />
              {product.withText && (
                <Text variant="body-bold">{product.text}</Text>
              )}
            </>
          )}
        </div>
        <Separator className="mt-2" />
      </div>
      <div>
        <div className="pb-4 pt-4">
          <div className="flex flex-col gap-2">
            {product.datasets.map((dataset: ProductDataSet) => (
              <Link
                key={dataset.text}
                className={clsx(
                  'flex cursor-pointer items-center justify-between rounded-lg border border-subdued p-4',
                  styles.dashboardItem
                )}
                href={dataset.link}
                target={dataset.link.indexOf('/') > 0 ? '_blank' : '_self'}
                rel={dataset.link.indexOf('/') > 0 ? 'noopener noreferrer' : ''}
                onClick={() => {
                  trackClickDashboardItem({
                    group: `${product.text}`,
                    name: `${dataset.text}`,
                  })

                  // Only show when it is not internal link
                  if (dataset.link.indexOf('/') > 0) {
                    setTimeout(() => {
                      showSurvey('PRIORITAS')
                    }, 500)
                  }
                }}
              >
                <div className="flex flex-col gap-2">
                  <Text>{dataset.text}</Text>
                  {dataset.link === '#' && (
                    <div>
                      <Badge variant="expressive-critical">Not Ready</Badge>
                    </div>
                  )}
                </div>
                <Icon>keyboard_arrow_right</Icon>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export const DashboardItems = () => {
  const { isActive: isRaporPublikActive } = useIsActiveFF({
    code: FLAG_KEY_RAPOR_PUBLIK,
    envVal: process.env.NEXT_PUBLIC_FEATURE_RAPOR_PUBLIK,
  })

  const productDataSets = getProductDataSets({
    withRaporPublik: isRaporPublikActive,
  })

  return (
    <DownloadSurveyProvider initialSource="PRIORITAS">
      <ContainerNoPadding className="my-4">
        <div className="flex flex-col gap-4 px-4 md:px-0">
          <Text className="mb-4" variant="heading-md">
            Daftar Kedataan
          </Text>
          {productDataSets.map((product) => (
            <ProductItem key={product.text} product={product} />
          ))}
        </div>
      </ContainerNoPadding>
    </DownloadSurveyProvider>
  )
}
